import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import ExamListTable from './ExamList';
const ExamList = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Exam List' parent='Exam List'  />
      <Container fluid={true}>
        <Row>
          <ExamListTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default ExamList;
